module.exports = __webpack_public_path__ + "ai.0e3df55d54ef71f36834.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/ai.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/ai.svg
// module chunks = styles